import { render, staticRenderFns } from "./storechoose.vue?vue&type=template&id=f2572572&scoped=true"
import script from "./storechoose.vue?vue&type=script&lang=js"
export * from "./storechoose.vue?vue&type=script&lang=js"
import style0 from "./storechoose.vue?vue&type=style&index=0&id=f2572572&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2572572",
  null
  
)

export default component.exports